import React from "react";
import {useForm} from "react-hook-form";
import {Box, Button, Card, CardActions, CardContent, Link, TextField, Typography} from "@mui/material";
import {useLocation, useNavigate} from "react-router-dom";
import Title from "../images/title.webp";
import {login} from "../api/client";

export default function Login(props) {
  const navigate = useNavigate();
  const [error, setError] = React.useState(useLocation().state);
  const {register, getValues} = useForm();
  const onSubmit = () => {
    sessionStorage.setItem("cpCd", getValues("cpCd"));
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        login({...getValues(), latitude: position.coords.latitude, longitude: position.coords.longitude}).then(response => {
          sessionStorage.setItem("xCsrfToken", response.headers["x-csrf-token"]);
          sessionStorage.setItem("stffNo", response.data.stffNo);
          sessionStorage.setItem("stffNm", response.data.stffNm);
          sessionStorage.setItem("adminFg", response.data.adminFg);
          navigate("/day_schedule");
        }).catch(error => {
          if (Boolean(error.response && error.response.data)) {
            setError(error.response.data.errors[0]);
          } else {
            props.setToastState({...props.toastState, message: null, error: true, networkError: true});
          };
        });
      },
      positionError => {
        login(getValues()).then(response => {
          sessionStorage.setItem("xCsrfToken", response.headers["x-csrf-token"]);
          sessionStorage.setItem("stffNo", response.data.stffNo);
          sessionStorage.setItem("stffNm", response.data.stffNm);
          sessionStorage.setItem("adminFg", response.data.adminFg);
          navigate("/day_schedule");
        }).catch(error => {
          if (Boolean(error.response && error.response.data)) {
            setError(error.response.data.errors[0]);
          } else {
            props.setToastState({...props.toastState, message: null, error: true, networkError: true});
          };
        });
      });
    } else{
      login(getValues()).then(response => {
        sessionStorage.setItem("xCsrfToken", response.headers["x-csrf-token"]);
        sessionStorage.setItem("stffNo", response.data.stffNo);
        sessionStorage.setItem("stffNm", response.data.stffNm);
        sessionStorage.setItem("adminFg", response.data.adminFg);
        navigate("/day_schedule");
      }).catch(error => {
        if (Boolean(error.response && error.response.data)) {
          setError(error.response.data.errors[0]);
        } else {
          props.setToastState({...props.toastState, message: null, error: true, networkError: true});
        };
      });
    };
  };

  React.useEffect(() => {
    sessionStorage.clear();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      alignItems = "center"
      display = "flex"
      flexDirection = "column"
      padding = {2}
      sx = {{p: 0, flexGrow: 1}}
    >
      <Box
        alt = "icon"
        className = "header-icon"
        component = "img"
        src = {Title}
      />
      <Typography
        className = "title"
        sx = {{mt: 2}}
      >
        訪問アプリ
      </Typography>
      <Card
        variant = "outlined"
        style = {{display: "block", transitionDuration: "0.3s", maxWidth: "400px", marginTop: 20, border: "none"}}
      >
        <CardContent>
          <TextField
            fullWidth
            label = "法人ID*"
            sx = {{mt: 1}}
            {...register("cpCd")}
            // type = "number"
          />
          <TextField
            fullWidth
            label = "職員ID*"
            sx = {{mt: 1}}
            {...register("stffCd")}
            // type = "number"
          />
          <TextField
            fullWidth
            label = "パスワード*"
            sx = {{mt: 1}}
            type = "password"
            {...register("password")}
          />
          <Typography
            color = "error.main"
            variant = "subtitle2"
          >
            {error}
          </Typography>
        </CardContent>
        <CardActions
        >
          <Button
            className = "btn-submit"
            onClick = {() => onSubmit()}
            size = "large"
            sx = {{width: "100%"}}
            variant = "contained"
          >
            <Typography
              className = "btn-txt-lg"
            >
              ログイン
            </Typography>
          </Button>
        </CardActions>
        <CardContent>
          <Typography
            variant = "subtitle2"
          >
            本アプリでは、位置情報を使用します。
          </Typography>
          <Typography
            variant = "subtitle2"
          >
            位置情報設定が有効になっていない場合、
          </Typography>
          <Typography
            variant = "subtitle2"
          >
            正しく動作しないおそれがあります。 (
            {/* TODO: 製品マニュアルへのリンク貼付 */}
            <Link
              color = "accentS.main"
              href = "https://sp.raku-care.jp/faqs/"
              target = "_blank"
            >
              詳細
            </Link>
            )
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};
